const eyesTrainerState = 'eyesTrainer';
const themeKey = 'eyesTrainer_theme';
const audioKey = 'eyesTrainer_audio';
const avatarKey = 'eyesTrainer_avatar';
const nicknameKey = 'eyesTrainer_nickname';

export const loadState = () => {
    try {
        let appState = localStorage.getItem(eyesTrainerState);
        if (appState === null) {
            return undefined
        }
        return JSON.parse(appState);
    } catch (e) {
        console.error('Can\'t load state', e)
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        let serializedState = JSON.stringify(state);
        localStorage.setItem(eyesTrainerState,serializedState);
    } catch (e) {
        console.error('Can\'t save state', e)
    }
};

// Theme preference (dark/light)
export const getTheme = () => {
    try {
        const theme = localStorage.getItem(themeKey);
        if (theme === null) {
            // Check system preference for first-time visitors
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
                return 'light';
            }
            return 'dark';
        }
        return theme;
    } catch (e) {
        console.error('Can\'t load theme', e);
        return 'dark';
    }
};

export const setTheme = (theme) => {
    try {
        localStorage.setItem(themeKey, theme);
        // Apply theme to document
        document.documentElement.setAttribute('data-theme', theme);
    } catch (e) {
        console.error('Can\'t save theme', e);
    }
};

export const applyTheme = () => {
    const theme = getTheme();
    document.documentElement.setAttribute('data-theme', theme);
    return theme;
};

// Audio preference (enabled/disabled)
export const getAudioEnabled = () => {
    try {
        const audio = localStorage.getItem(audioKey);
        // Default to disabled (user must opt-in)
        return audio === 'true';
    } catch (e) {
        console.error('Can\'t load audio preference', e);
        return false;
    }
};

export const setAudioEnabled = (enabled) => {
    try {
        localStorage.setItem(audioKey, enabled ? 'true' : 'false');
    } catch (e) {
        console.error('Can\'t save audio preference', e);
    }
};

// Avatar preference (dog/cat/owl/moose/classic)
export const getAvatar = () => {
    try {
        const avatar = localStorage.getItem(avatarKey);
        return avatar || 'dog';
    } catch (e) {
        console.error('Can\'t load avatar preference', e);
        return 'dog';
    }
};

export const setAvatar = (avatar) => {
    try {
        localStorage.setItem(avatarKey, avatar);
    } catch (e) {
        console.error('Can\'t save avatar preference', e);
    }
};

// Nickname preference
export const getNickname = () => {
    try {
        return localStorage.getItem(nicknameKey) || '';
    } catch (e) {
        return '';
    }
};

export const setNickname = (name) => {
    try {
        localStorage.setItem(nicknameKey, name);
    } catch (e) {
        console.error('Can\'t save nickname', e);
    }
};

// Last workout (for quick-start)
const lastWorkoutKey = 'eyesTrainer_lastWorkout';

export const getLastWorkout = () => {
    try {
        const data = localStorage.getItem(lastWorkoutKey);
        return data ? JSON.parse(data) : null;
    } catch (e) {
        return null;
    }
};

export const setLastWorkout = (key, name) => {
    try {
        localStorage.setItem(lastWorkoutKey, JSON.stringify({ key, name, date: Date.now() }));
    } catch (e) {
        // silently fail
    }
};
